import * as React from 'react';
import {Svg, Path} from 'react-native-svg';

const ClockIcon = props => {
  return (
    <Svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 2.292a6.042 6.042 0 100 12.083A6.042 6.042 0 008 2.292zM.708 8.333a7.292 7.292 0 1114.584 0 7.292 7.292 0 01-14.584 0z"
        fill="#5C697B"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 3.542c.345 0 .625.28.625.625v3.82l2.206 1.379a.625.625 0 01-.662 1.06l-2.5-1.563a.625.625 0 01-.294-.53V4.167c0-.346.28-.625.625-.625zM3.442.391a.625.625 0 010 .884L1.359 3.36a.625.625 0 01-.884-.884L2.558.39a.625.625 0 01.884 0zM12.558.391a.625.625 0 000 .884l2.083 2.084a.625.625 0 00.884-.884L13.442.39a.625.625 0 00-.884 0z"
        fill="#5C697B"
      />
    </Svg>
  );
};

export default ClockIcon;
